export default {
    //模块地址
    storeType:'storeList',
    //组件地址
    componentType:'storeImg',
    //商品ID
    productId:'',
    //商品订单模块地址
    storeOrderType:'orderList',
    //订单ID
    orderId:'',
    //订单详情组件地址
    orderComponet:'orderSlide',
    //订单信息
    orderRefundInfo:{},
    
}


// WEBPACK FOOTER //
// ./src/vuex/store/state.js